/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ state: NonNullable<unknown> }} Actuator_SpeedInputs */



/**
* | state | output |
* | --- | --- |
* | "0" | "Off" |
* | "1" | "Low speed" |
* | "2" | "Medium speed" |
* | "3" | "High speed" |
* | * | "Off" |
*
* @param {Actuator_SpeedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const actuator_speed = /** @type {((inputs: Actuator_SpeedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actuator_SpeedInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		if ((i?.state === 0 || i?.state === "0")) return /** @type {LocalizedString} */ (`Off`);
		if ((i?.state === 1 || i?.state === "1")) return /** @type {LocalizedString} */ (`Low speed`);
		if ((i?.state === 2 || i?.state === "2")) return /** @type {LocalizedString} */ (`Medium speed`);
		if ((i?.state === 3 || i?.state === "3")) return /** @type {LocalizedString} */ (`High speed`);
		return /** @type {LocalizedString} */ (`Off`)
	}
	{
		if ((i?.state === 0 || i?.state === "0")) return /** @type {LocalizedString} */ (`Éteint`);
		if ((i?.state === 1 || i?.state === "1")) return /** @type {LocalizedString} */ (`Petite vitesse`);
		if ((i?.state === 2 || i?.state === "2")) return /** @type {LocalizedString} */ (`Moyenne vitesse`);
		if ((i?.state === 3 || i?.state === "3")) return /** @type {LocalizedString} */ (`Grande vitesse`);
		return /** @type {LocalizedString} */ (`Éteint`)
	}
});